import React from 'react';
import { IconBaseProps } from 'react-icons/lib';

const Icon = (props: IconBaseProps) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M12.0064 3.89763C11.5044 3.89763 11.099 4.30307 11.099 4.80505L11.0925 11.0926L4.79854 11.0926C4.29657 11.0926 3.89113 11.498 3.89113 12C3.89113 12.502 4.29657 12.9074 4.79854 12.9074L11.0925 12.9074L11.0925 19.2014C11.0925 19.7034 11.498 20.1088 11.9999 20.1088C12.5019 20.1088 12.9073 19.7034 12.9073 19.2014L12.9073 12.9074L19.2013 12.9074C19.7033 12.9074 20.1087 12.502 20.1087 12C20.1087 11.498 19.7033 11.0926 19.2013 11.0926L12.9073 11.0926L12.9073 4.79861C12.9073 4.30951 12.4955 3.89763 12.0064 3.89763Z"
			fill={props.color}
		/>
	</svg>
);

export default Icon;
